export class GetSecurityQuestionRequestViewModel {
  public refNo: string;
  public screeningId: number = 0;
  public questionId: number = 0;
  public sqType: string;

}
